// @generated by protoc-gen-connect-es v0.8.6 with parameter "target=ts,import_extension="
// @generated from file analytics/v2/service.proto (package analytics.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  CountRequest,
  CountResponse,
  HealthCheckRequest,
  HealthCheckResponse,
  RangeSummaryRequest,
  RangeSummaryResponse,
  SummaryRequest,
  SummaryResponse,
  TopCodesRequest,
  TopCodesResponse,
  TopDestinationsRequest,
  TopDestinationsResponse,
  TopLinksRequest,
  TopLinksResponse,
  TopPagesRequest,
  TopPagesResponse,
  TopUTMCampaignsRequest,
  TopUTMCampaignsResponse,
  TopUTMReferrersRequest,
  TopUTMReferrersResponse,
  TopUTMTermsRequest,
  TopUTMTermsResponse
} from './service_pb'
import { MethodKind } from '@bufbuild/protobuf'

/**
 * Service
 *
 * @generated from service analytics.v2.AnalyticsService
 */
export const AnalyticsService = {
  typeName: 'analytics.v2.AnalyticsService',
  methods: {
    /**
     * @generated from rpc analytics.v2.AnalyticsService.HealthCheck
     */
    healthCheck: {
      name: 'HealthCheck',
      I: HealthCheckRequest,
      O: HealthCheckResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.RangeSummary
     */
    rangeSummary: {
      name: 'RangeSummary',
      I: RangeSummaryRequest,
      O: RangeSummaryResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.Summary
     */
    summary: {
      name: 'Summary',
      I: SummaryRequest,
      O: SummaryResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.Count
     */
    count: {
      name: 'Count',
      I: CountRequest,
      O: CountResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopCodes
     */
    topCodes: {
      name: 'TopCodes',
      I: TopCodesRequest,
      O: TopCodesResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopDestinations
     */
    topDestinations: {
      name: 'TopDestinations',
      I: TopDestinationsRequest,
      O: TopDestinationsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopPages
     */
    topPages: {
      name: 'TopPages',
      I: TopPagesRequest,
      O: TopPagesResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopLinks
     */
    topLinks: {
      name: 'TopLinks',
      I: TopLinksRequest,
      O: TopLinksResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopUTMCampaigns
     */
    topUTMCampaigns: {
      name: 'TopUTMCampaigns',
      I: TopUTMCampaignsRequest,
      O: TopUTMCampaignsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopUTMTerms
     */
    topUTMTerms: {
      name: 'TopUTMTerms',
      I: TopUTMTermsRequest,
      O: TopUTMTermsResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc analytics.v2.AnalyticsService.TopUTMReferrers
     */
    topUTMReferrers: {
      name: 'TopUTMReferrers',
      I: TopUTMReferrersRequest,
      O: TopUTMReferrersResponse,
      kind: MethodKind.Unary
    }
  }
} as const
